import AmexPlatinumNightsCard from './AmexPlatinumNightsCard';

export default AmexPlatinumNightsCard;
